var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "avatar-wrapper flex"
  }, [_c("a-avatar", {
    attrs: {
      src: _vm.imgUrl,
      size: 135
    }
  }), _c("div", {
    staticClass: "upload"
  }, [_c("a-upload", {
    attrs: {
      name: "avatar",
      accept: "image/png,image/gif,image/jpeg",
      "before-upload": _vm.beforeUpload,
      "show-upload-list": false
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      icon: "picture",
      loading: _vm.loading
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("选择图片")) + " ")])], 1)], 1), _c("a-modal", {
    attrs: {
      title: _vm.$t("头像裁剪"),
      visible: _vm.modalShow,
      footer: null,
      width: 800
    },
    on: {
      cancel: function ($event) {
        _vm.modalShow = false;
      }
    }
  }, [_c("a-row", {
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    staticClass: "cropper-wrapper",
    attrs: {
      span: 12
    }
  }, [_c("vueCropper", {
    ref: "cropper",
    attrs: {
      img: _vm.option.imgUrl,
      info: true,
      autoCrop: _vm.option.autoCrop,
      autoCropWidth: _vm.option.autoCropWidth,
      autoCropHeight: _vm.option.autoCropHeight,
      fixedBox: _vm.option.fixedBox
    },
    on: {
      realTime: _vm.realTime
    }
  })], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-space", {
    attrs: {
      size: 15
    }
  }, [_c("a-button", {
    attrs: {
      icon: "plus"
    }
  }), _c("a-button", {
    attrs: {
      icon: "minus"
    }
  }), _c("a-button", {
    attrs: {
      icon: "undo"
    }
  }), _c("a-button", {
    attrs: {
      icon: "redo"
    }
  }), _c("a-button", {
    attrs: {
      type: "primary",
      icon: "picture",
      loading: _vm.loading
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("重新选择图片")) + " ")])], 1), _c("div", {
    staticClass: "accountImg"
  }, [_c("img", {
    style: _vm.previewsImg.img,
    attrs: {
      src: _vm.previewsImg.url,
      alt: ""
    }
  })]), _c("a-button", {
    staticStyle: {
      "margin-left": "150px"
    },
    attrs: {
      type: "primary",
      icon: "upload"
    },
    on: {
      click: _vm.saveHeadImg
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存头像")) + " ")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };